import React from "react";
import { LogoContainer, LogoImg } from "./style";
import { logo_url_dev } from "../../../config";

const Logo = (props) => {
	return (
		<LogoContainer style={{ ...props.style }}>
			<LogoImg src={logo_url_dev} />
		</LogoContainer>
	);
};

Logo.propTypes = {};

export default Logo;
